import VTour from './VTour';
import VStep from './VStep';

const VueTour = {
  install(Vue, options) {
    Vue.component(VTour.name, VTour);
    Vue.component(VStep.name, VStep);

    console.log('Setting tours on Vue prototype.');

    // Object containing Tour objects (see VTour.vue) where the tour name is used as key
    Vue.prototype.$tours = {};
  },
};

export default VueTour;

if (typeof window !== 'undefined' && window.Vue) {
  console.log('From main.js - Useing VueTours with:', window);
  window.Vue.use(VueTour);
}
